export enum PagingError {
    None,
    IncorrectPageIndex,
    IncorrectRecordsPerPage
}

export declare interface IPagingState {
    index: number;
    recordsPerPage: number;
    metadata?: {
        countPages: number;
        error: PagingError;
        countRecords: number;
    };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/data-operations/paging-state.interface.ts